import { useHistory } from "react-router-dom";

// Components
import WelcomeCarousel from "./WelcomeCarousel";

const WelcomeCarouselContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * End Hooks
     */

    return <WelcomeCarousel {...props} history={history} />;
};

export default WelcomeCarouselContainer;
